import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import { URI_PATHS, VALID_AGE } from "../../../constants";
import { TERMS_AND_PP_ERROR_MESSAGE, NO_BANK_ACCOUNTS_ERROR_MESSAGE } from "./constants";

import ContinueButton from "../common/ContinueButton";
import withQuery from "../wrappers/gql/withQuery";
import { GET_APP_INFO_AND_ACCOUNTS } from "../../../api/gql";

const ConfirmV2Form = ({ data: applicationInfo, _completeStep }) => {
  const { accountsByLogin } = applicationInfo.getBankAccounts;

  const history = useHistory();

  const [termsAndPPChecked, setTermsAndPPChecked] = useState(false);
  const [error, setError] = useState("");

  const isFormValid = () => {
    if(!termsAndPPChecked){
      setError(TERMS_AND_PP_ERROR_MESSAGE);
      return false;
    }

    if(!accountsByLogin){
      setError(NO_BANK_ACCOUNTS_ERROR_MESSAGE);
      return false;
    }

    setError("");
    return true;
  };

  const onFormSubmission = () => {
    if (!isFormValid())
      return;

    _completeStep();
  };

  return (
    <>
      <button
        className="addAccBtn w-full py-2 rounded text-lg bg-green-primary text-white cursor-pointer"
        onClick={() => history.push(URI_PATHS.LINK_BANK)}
        type="button"
      >+ Add more
      </button>
      <div className="mt-4">
        { error && <div className="errorText">{error}</div> }
        <input type="checkbox" checked={termsAndPPChecked} onChange={() => setTermsAndPPChecked(!termsAndPPChecked)} />
        <span className="ml-2 font-open-sans text-sm">
          {
            `By continuing I certify that I am ${VALID_AGE} years of age, and I 
            agree to the`
          }
        </span>{" "}
        <a
          href="https://tomo-public-docs.s3.us-west-1.amazonaws.com/TermsOfUse.pdf"
          target="_blank"
          rel="noopener noreferrer"
          className="text-primary font-open-sans"
        >
          Terms of Use
        </a>
        <span>, </span>
        <a
          href="/privacypolicy"
          target="_blank"
          className="text-primary font-open-sans"
        >
          Privacy Policy
        </a>
        <span>, and </span>
        <a
          href="https://tomo-public-docs.s3.us-west-1.amazonaws.com/Tomo-+ESIGN+Consent+Disclosure.pdf"
          target="_blank"
          rel="noopener noreferrer"
          className="text-primary font-open-sans"
        >
          e-Sign.
        </a>
      </div>
      <ContinueButton buttonText="Submit" onClick={onFormSubmission} />
    </>
  );
};

export default withQuery(GET_APP_INFO_AND_ACCOUNTS)(ConfirmV2Form);